import React, { useEffect, useState } from "react";
import {
  Form, Input, DatePicker, TimePicker, Select, Mentions, Button, message,
  Checkbox, Radio, Modal, Table, InputNumber
 } from 'antd';
import './forms.scss';

const { TextArea } = Input;
const { Option } = Select;

const FormItem = Form.Item;

const EditTourIndicatorsForm = React.memo(({ loading, resource, itemDetails, user, confirmDialogue,
 tourIndicatorsTableDataSource, tourIndicators, jobElementsByTour, tourIndicator,
 indicatorsByTour, codesByIndicator, ...props
}) => {
  const { itemType } = itemDetails;
  const { getFieldDecorator, getFieldsError, getFieldsValue } = props.form;
  const [ selectedRowKeysArray, setSelectedRowKeysArray ] = useState([0]);
  const [ dirtyTableRows, setDirtyTableRows ] = useState(false);

  const columns = [
    {
      title: 'Indicator',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Code',
      dataIndex: 'codeName',
      key: 'codeName',
    },
    {
      title: 'Assignment',
      dataIndex: 'assignment',
      key: 'assignment',
    },
    {
      title: 'Cost',
      dataIndex: 'cost',
      key: 'cost',
    }
  ];

  const handleSelectedRowChange = async (selectedRowKeys) => {
    setSelectedRowKeysArray(selectedRowKeys);
    await props.getTourIndicator(tourIndicators.data.find((elem) => elem.id === tourIndicatorsTableDataSource[selectedRowKeys[0]].id).id);
    console.log(selectedRowKeys); // debug
  }

  const rowSelection = {
    selectedRowKeys: selectedRowKeysArray, // Table component's selectedRowKeys is always an array
    onChange: handleSelectedRowChange,
    type: 'radio',
    onSelect: async (record, selected) => {
      // console.log(selected);
      // console.log(record);
    }
   };

  const invalidForm = () => {
    message.config({
      top: 150,
      duration: 5,
      maxCount: 5,
    });
    message.error('You have one or more invalid form inputs!');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    // collect all fields currently in error state
    for ( const [field, error] of Object.entries(getFieldsError()) ) {
      if (error) {
        errors[`${field}`] = error;
      }
    }
    if (Object.values(errors).length === 0) {
      console.log('Success! Received values of form: ', getFieldsValue())
      if (tourIndicator) {
        props.updateTourIndicator();
      } else if (!tourIndicator) {
        props.createTourIndicator();
      }
    } else {
      invalidForm();
      console.log('Invalid Form! ', errors);
    }
  };

  useEffect(() => {
    itemDetails.itemType = 'tourIndicator';
    props.updateState({itemDetails});
  },[]);

  useEffect(() => {
    const form = props.form;
      form.setFieldsValue({
        cost: itemDetails.cost,
      });
  }, [itemDetails.tourIndicatorId]);

  useEffect(() => {
    if (!dirtyTableRows) {
      // set tourIndicator initially selected when tab opens
      let selectedTourIndicator = tourIndicators.data[0];
      itemDetails.selectedTourIndicatorDetails = selectedTourIndicator;
      props.updateState({itemDetails});
    }
    setDirtyTableRows(true);
  }), [];

  // update fields from new indicator selection
  useEffect(() => {
    if (itemDetails && tourIndicator && tourIndicator.data) {
      itemDetails.tourIndicatorId = tourIndicator.data[0].id;
      itemDetails.indicatorId = tourIndicator.data[0].indicatorId;
      itemDetails.codeId = tourIndicator.data[0].codeId;
      itemDetails.jobElementId = tourIndicator.data[0].jobElementId;
      itemDetails.billable = tourIndicator.data[0].billable;
      itemDetails.cost = tourIndicator.data[0].cost || 0.0;

      itemDetails.selectedTourIndicatorDetails = tourIndicator.data[0];

    } else if (itemDetails && !tourIndicator) {
      // clear fields for create new indicator form
      itemDetails.tourIndicatorId = null;
      itemDetails.indicatorId = null;
      itemDetails.codeId = null;
      itemDetails.jobElementId = null;
      itemDetails.billable = null;
      itemDetails.cost = null;
    }
    props.updateState({itemDetails});
  },[itemDetails, tourIndicator, selectedRowKeysArray])


  const switchToNewIndicatorForm = async () => {
    tourIndicator = null;
    props.updateState({tourIndicator});
    setSelectedRowKeysArray(null); // un-select anything in table
  }

  // hook for code dropdown
  useEffect(() => {
    if (itemDetails.indicatorId) {
      props.getCodesByIndicator()
    }
  }, [itemDetails, itemDetails.indicatorId])

  if (itemDetails && !loading
    ) {
    // console.log(`selectedRowKeysArray: ${selectedRowKeysArray}`) // debug
    console.log(`dirtyTableRows: ${dirtyTableRows}`);
    return (

      <Form onSubmit={handleSubmit}>

          <FormItem>
            <Table
              dataSource={tourIndicatorsTableDataSource}
              columns={columns}
              rowSelection={rowSelection}
              // rowClassName={(record) =>  record.color ? record.color.replace('#', '') : null}
              // onRow={(record) => record.key === selectedRowKeysArray[0] ? record.color = 'greenRow' : null}
              // ßrowClassName={(record) => ''}
            />
          </FormItem>

          <FormItem
                label={<span><span id="asterisk">* </span><span>Indicator</span></span>}
                style={{ display: "flex", marginBottom: 5 }}
              >
                <Select
                  name="indicatorId"
                  value={`indicatorId-${itemDetails.indicatorId ? itemDetails.indicatorId.toString() : 0}`}
                  onChange={props.handleOmnibusFieldChange}
                  style={{ width: 250 }}
                >
                  <Option key={null} value={`indicatorId-${0}`}>&nbsp;</Option>

                  { indicatorsByTour &&
                    indicatorsByTour.data.map((elem) => {
                    return <Option key={elem.id} value={`indicatorId-${elem.id}`}>{elem.name}</Option>
                  })}
                </Select>
              </FormItem>

              <FormItem
                label={<span><span id="asterisk">* </span><span>Code</span></span>}
                style={{ display: "flex", marginBottom: 5 }}
              >
                <Select
                  name="codeId"
                  value={`codeId-${itemDetails.codeId ? itemDetails.codeId.toString() : 0}`}
                  onChange={props.handleOmnibusFieldChange}
                  style={{ width: 150 }}
                >
                  <Option key={null} value={`codeId-${0}`}>&nbsp;</Option>

                  { codesByIndicator &&
                    codesByIndicator.data.map((elem) => {
                    return <Option key={elem.id} value={`codeId-${elem.id}`}>{elem.name}</Option>
                  })}
                </Select>
              </FormItem>

              <FormItem
                label={'Assignment'}
                style={{ display: "flex", marginBottom: 5 }}
              >
                <Select
                  name="jobElementId"
                  value={`jobElementId-${itemDetails.jobElementId ? itemDetails.jobElementId.toString() : -1}`}
                  onChange={props.handleOmnibusFieldChange}
                  style={{ width: 300 }}
                >
                  {/* <Option key={null} value={`jobElementId-${0}`}>&nbsp;</Option> */}
                  <Option key={null} value={`jobElementId-${-1}`}>&nbsp;</Option>

                  { jobElementsByTour &&
                    jobElementsByTour.data.map((elem) => {
                    return <Option key={elem.id} value={`jobElementId-${elem.id}`}>
                      {`${elem.jobNumber}/${elem.startActual.split('T')[1].slice(0,5)}-${elem.endActual.split('T')[1].slice(0, 5)}/${elem.service}`}
                      </Option>
                  })}
                </Select>
              </FormItem>

              <FormItem
                  label="Billable"
                  style={{ display: "flex", marginBottom: 5 }}
                >
                   {getFieldDecorator('billable', {
                      })(
                        <Checkbox
                          name="billable"
                          checked={itemDetails.billable}
                          onChange={props.handleOmnibusFieldChange}
                          disabled={tourIndicator}
                          size={'large'}
                        />
                    )}
              </FormItem>

              <FormItem
                      label="Cost"
                      style={{ display: "flex", marginBottom: 5 }}
                >
                  {getFieldDecorator('cost', {
                      rules: [{
                        required: true, message: 'Please input cost!',
                    }],
                  })(
                    <InputNumber
                      name="cost"
                      onChange={(e) => props.handleOmnibusFieldChange(`cost-${e}`)}
                      disabled={tourIndicator}
                      />
                  )}
                </FormItem>

              <FormItem
                style={{ marginTop: 20 }}
              >
              { tourIndicator &&
                (
                  <React.Fragment>
                    <Button type="primary" ghost size={'large'} htmlType="submit">
                      Update
                    </Button>
                    <Button type="danger" ghost size={'large'} onClick={() => props.handleItemDelete('tourIndicator')} >
                      Delete
                    </Button>
                    <Button type="default" size={'large'} onClick={() => switchToNewIndicatorForm()} >
                      New
                  </Button>
                  </React.Fragment>
                )
              }
              { !tourIndicator &&
                  <Button type="default" size={'large'} htmlType="submit">
                    Save
                  </Button>
              }
              </FormItem>

      </Form>
      );
  } else return 'loading...'
})

export default EditTourIndicatorsForm;

